export default function StructuralProductsDescription() {
  return <section id="structural-products-description" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <p className="text-lg md:text-xl text-foreground/80 leading-relaxed text-center font-default">
          Se utilizan en la fabricación de estructuras metálicas para
          construcciones industriales, señalamientos, invernaderos, entre otras.
          Son elementos que forman la parte resistente de una construcción. El
          sistema estructural en acero se basa en un marco o esqueleto de
          cualquier estructura cuyos componentes principales son columnas y
          vigas de acero.
        </p>
      </div>
    </section>;
}